module.exports = __webpack_public_path__ + "img/icon_calendar.a7b37caa.svg";